// Static editable content for The Mogul Group Advisors.
// All text intentionally kept plain-JS so it can be extracted to a CMS later.

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwYnVzaW5lc3MlMjBtZWV0aW5nJTIwb2ZmaWNlfGVufDB8fHx8MTc4NDczODEyN3ww&ixlib=rb-4.1.0&q=85",
  heroSecondary: "https://images.unsplash.com/photo-1573167507387-6b4b98cb7c13?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxkaXZlcnNlJTIwYnVzaW5lc3MlMjBtZWV0aW5nJTIwb2ZmaWNlfGVufDB8fHx8MTc4NDczODEyN3ww&ixlib=rb-4.1.0&q=85",
  dallas: "https://images.unsplash.com/photo-1625950019503-cae6a7825762",
  restaurant: "https://images.pexels.com/photos/6018426/pexels-photo-6018426.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  retail: "https://images.pexels.com/photos/3738387/pexels-photo-3738387.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  contractor: "https://images.pexels.com/photos/14989317/pexels-photo-14989317.jpeg",
  startup: "https://images.pexels.com/photos/5961077/pexels-photo-5961077.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  founder: "https://customer-assets-jai6qajn.emergentagent.net/job_mogul-build/artifacts/s07n75za_Shannen%20Alexander%20Suit.png",
  laptop: "https://images.pexels.com/photos/4884110/pexels-photo-4884110.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  plumber: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=940&q=80",
  hotel: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=940&q=80",
  professional: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=940&q=80",
  community: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=940&q=80",
};

export const FOUNDER = {
  name: "Shannen \"Alex\" Alexander",
  short: "Alex",
  title: "Founder & CEO",
  photo: "https://customer-assets-jai6qajn.emergentagent.net/job_mogul-build/artifacts/s07n75za_Shannen%20Alexander%20Suit.png",
  tagline: "From operational chaos to structured growth.",
  subtagline: "15+ years of leadership across hospitality operations, enterprise sales, and business development — now focused on helping owner-led businesses do the same.",
  quote: "Help owners build companies that run with clarity, strong leadership, and sustainable growth.",
  stats: [
    { value: "15", suffix: "+ Years", label: "of Leadership, Operations & Business Development Experience" },
    { value: "8", suffix: "+ Years", label: "as a General Manager in Hospitality" },
    { value: "5", suffix: "", label: "Pillars of the Mogul Growth Framework™" },
    { value: "3", suffix: "", label: "Practice Areas: Growth Strategy, Brand & Digital, Operations & CX" },
  ],
  bio: [
    "Shannen \"Alex\" Alexander is an entrepreneur, business strategist, and operations leader dedicated to helping businesses strengthen their foundations and build sustainable growth.",
    "With over 15 years of leadership experience across hospitality operations, enterprise sales, and business development, Alex has worked with organizations ranging from locally owned businesses to nationally recognized companies. His work focuses on helping business owners bring clarity to their strategy, improve operational systems, and build organizations structured for long-term success.",
    "Alex's leadership journey began in the hospitality industry, where he spent 8+ years as a General Manager leading high-volume restaurant operations and managing teams in fast-paced environments. During this time, he developed a deep understanding of the operational challenges small businesses face every day: managing staff, customer experience, financial performance, and operational efficiency. These early years shaped his practical, results-driven approach to business leadership.",
    "As his career evolved, Alex expanded into enterprise sales leadership and strategic partnerships at organizations like T-Mobile and Uber Technologies, where he helped develop partnerships, manage client relationships, and support operational growth initiatives in complex business environments. Through these experiences, Alex gained a unique perspective that combines front-line operational leadership with strategic business development.",
    "Recognizing that many small businesses struggle not from lack of effort but from unclear systems and strategy, Alex founded The Mogul Group. The firm was created to help business owners strengthen the critical areas that drive performance: strategy, operations, brand positioning, customer experience, and leadership.",
    "Through The Mogul Group, Alex works with small businesses, restaurants, startups, and entrepreneurs who want to move beyond daily chaos and build organizations that operate with clarity and consistency. His advisory work is guided by the Mogul Growth Framework™ — a structured methodology that helps business owners evaluate the core pillars influencing business performance.",
  ],
  chapters: [
    {
      n: "01",
      title: "Chapter One",
      heading: "Hospitality Operations",
      body: "Eight-plus years as a General Manager leading high-volume restaurant operations, staffing, customer experience, financial performance, and the daily grind of small business leadership.",
      tags: ["DJ's Steakhouse", "Ten01 Live", "Full Moon Café"],
    },
    {
      n: "02",
      title: "Chapter Two",
      heading: "Enterprise Sales",
      body: "Strategic partnerships and sales leadership at national organizations — developing partnerships, managing client relationships, and supporting operational growth in complex business environments.",
      tags: ["T-Mobile", "Uber Technologies", "National American University"],
    },
    {
      n: "03",
      title: "Chapter Three",
      heading: "The Mogul Group",
      body: "Founded to help business owners strengthen strategy, operations, brand, customer experience, and leadership — built on the Mogul Growth Framework™ and real operational experience.",
      tags: ["Founder & CEO", "Dallas, TX"],
    },
  ],
  missionHeadline: "Simple and non-negotiable.",
  missionBody: "Help business owners build stronger systems, lead with confidence, and create businesses designed for long-term success.",
};

export const TEAM = [
  {
    slug: "alex",
    name: "Shannen \"Alex\" Alexander",
    title: "Founder & CEO",
    photo: "https://customer-assets-jai6qajn.emergentagent.net/job_mogul-build/artifacts/s07n75za_Shannen%20Alexander%20Suit.png",
    bio: "Business strategist and operations leader with 15+ years of leadership experience across hospitality and enterprise sales. Alex founded The Mogul Group to help business owners bring clarity to strategy, strengthen operations, and build companies designed for long-term success.",
    link: "/founder",
  },
  {
    slug: "ryan",
    name: "Ryan Cartwright",
    title: "Learning & Development",
    photo: "https://customer-assets-jai6qajn.emergentagent.net/job_mogul-build/artifacts/dvzdktpe_IMG_6356.webp",
    bio: "An expert in Learning & Development and customer service excellence. Ryan brings a wealth of knowledge in training teams to deliver consistent, high-value experiences that drive customer loyalty and operational precision.",
  },
  {
    slug: "travis",
    name: "Travis O. Smith",
    title: "Business & Customer Relations",
    photo: "https://customer-assets-jai6qajn.emergentagent.net/job_mogul-build/artifacts/c6emu59t_Travis%20Smith.PNG",
    bio: "Business and customer relations specialist. Travis focuses on strengthening the bond between brands and their clients through thoughtful engagement strategies and streamlined communications that improve retention and market presence.",
  },
];

export const CHALLENGES = [
  { title: "Unclear Direction", body: "The business is operating, but there is no focused plan for growth.", icon: "Compass" },
  { title: "Inconsistent Marketing", body: "The company needs stronger visibility, consistent content, and better customer engagement.", icon: "Megaphone" },
  { title: "Weak Online Presence", body: "The website, branding, or digital experience no longer represents the quality of the business.", icon: "MonitorSmartphone" },
  { title: "Operational Gaps", body: "Disorganized processes, unclear workflows, and daily inefficiencies are limiting growth.", icon: "Workflow" },
];

export const CORE_SERVICES = [
  { slug: "growth-strategy", title: "Business Growth & Strategy", tagline: "We help you grow.", body: "Assessment, growth strategy, revenue strategy, leadership advisory, and business development. The strategic foundation every engagement begins with.", icon: "LineChart" },
  { slug: "brand-digital", title: "Brand & Digital Growth", tagline: "We help you get seen and trusted.", body: "Brand management, digital marketing, web, social, campaigns, and customer acquisition — coordinated to serve the growth strategy, not sold as isolated services.", icon: "Sparkles" },
  { slug: "operations-cx", title: "Operations & Customer Experience", tagline: "We help you deliver consistently.", body: "Processes, SOPs, workflow, customer experience, team systems, and implementation — so strategy actually lives inside the business.", icon: "Settings2" },
];

export const PROCESS_STEPS = [
  { n: "01", title: "Assess", body: "We diagnose where growth is being restricted — strategy, marketing, brand, customer experience, and operations." },
  { n: "02", title: "Strategize", body: "We build a customized plan based on the real bottleneck, not a template." },
  { n: "03", title: "Execute", body: "We implement — marketing, brand, systems, or operations — with clear scope and defined deliverables." },
  { n: "04", title: "Measure", body: "We track what changed. Real metrics, not vanity numbers." },
  { n: "05", title: "Grow", body: "We refine the strategy as the business scales — because standing still is a decision too." },
];

export const INDUSTRIES = [
  { slug: "restaurants", name: "Restaurants & Hospitality", image: IMAGES.restaurant, body: "Menu-driven promotion, local visibility, delivery-app coordination, seasonal campaigns, and reservation systems that keep tables full." },
  { slug: "retail", name: "Retail Stores & Shops", image: IMAGES.retail, body: "Brand storytelling, in-store to online funnels, product-page strategy, and loyalty structures for repeat customers." },
  { slug: "contractors", name: "Contractors & Construction", image: IMAGES.contractor, body: "Lead-generation websites, project galleries, quoting workflows, and consistent job-site to customer communication." },
  { slug: "plumbing", name: "Plumbers & Home Services", image: IMAGES.plumber, body: "Emergency-ready websites, service-area SEO, booking forms, and review-driven local reputation building." },
  { slug: "hotels", name: "Hotels & Lodging", image: IMAGES.hotel, body: "Direct-booking positioning, guest-experience storytelling, seasonal promotions, and operational consistency." },
  { slug: "professional", name: "Professional Services", image: IMAGES.professional, body: "Credibility-first websites, referral systems, thoughtful content, and client onboarding built for trust." },
  { slug: "startups", name: "Startups & Entrepreneurs", image: IMAGES.startup, body: "Brand foundations, launch strategy, first-90-days marketing, and lean operational systems that scale." },
  { slug: "community", name: "Community-Based Organizations", image: IMAGES.community, body: "Mission-forward messaging, community campaigns, sponsor materials, and digital tools that expand reach." },
  { slug: "local", name: "Local Service Businesses", image: IMAGES.retail, body: "Neighborhood-first marketing, service-area SEO, and simple systems for scheduling, follow-up, and reviews." },
  { slug: "smb", name: "Small & Midsized Businesses", image: IMAGES.heroSecondary, body: "Multi-channel strategy, website redesigns, operational tune-ups, and ongoing advisory partnerships." },
];

export const SERVICE_SECTIONS = [
  {
    slug: "growth-strategy",
    title: "Business Growth & Strategy",
    lead: "The strategic core. Every engagement begins here — with clarity on where growth is being restricted and a plan to move forward.",
    items: [
      "Mogul Growth Assessment",
      "Business Growth Strategy",
      "Revenue & Pricing Strategy",
      "Customer Acquisition Strategy",
      "Customer Retention",
      "Leadership Advisory",
      "Business Development",
      "Strategic Partnerships",
      "Market Positioning",
    ],
  },
  {
    slug: "brand-digital",
    title: "Brand & Digital Growth",
    lead: "The marketplace layer. How your business is seen, understood, chosen, and remembered — coordinated to serve the strategy.",
    items: [
      "Brand Management & Positioning",
      "Digital Marketing Strategy",
      "Website Development & Redesign",
      "Social Media Strategy & Management",
      "Content Strategy",
      "Campaign Development",
      "Advertising Strategy",
      "Lead Generation",
      "Email Marketing",
      "Performance Reporting",
    ],
    disclaimer: "We do not promise specific advertising results.",
  },
  {
    slug: "operations-cx",
    title: "Operations & Customer Experience",
    lead: "The delivery layer. Where strategy becomes repeatable — so the business runs with clarity whether or not the owner is in the room.",
    items: [
      "Workflow & Process Development",
      "Standard Operating Procedures (SOPs)",
      "Customer Experience Systems",
      "Client Onboarding",
      "Scheduling & Service Systems",
      "Team Operating Rhythms",
      "Service Delivery Improvement",
      "Implementation Coaching",
      "Government & Proposal Readiness",
    ],
    disclaimer: "We do not guarantee contract awards, funding, revenue, approval, or procurement outcomes.",
  },
];

export const PACKAGES = [
  {
    slug: "advisory",
    name: "Mogul Growth Advisory",
    for: "Strategy-only advisory for owners who need clarity, direction, and accountability — without the execution overhead.",
    items: [
      "Monthly Strategy Session",
      "Ongoing Growth Planning",
      "Marketing & Brand Recommendations",
      "Performance Review",
      "Defined Monthly Priorities",
      "Direct Advisor Access",
    ],
    startingAt: "Begins at $1,250/mo",
  },
  {
    slug: "management",
    name: "Mogul Growth Management",
    for: "Our flagship engagement. Strategy plus one focused execution discipline — marketing, brand, or operations.",
    items: [
      "Everything in Advisory",
      "One Execution Discipline (Marketing, Brand, or Ops)",
      "Campaign & Content Direction",
      "Monthly Growth Meetings",
      "Performance Reporting",
      "Defined Marketing Execution",
      "Ongoing Optimization",
    ],
    startingAt: "Begins at $1,750/mo",
    highlight: true,
  },
  {
    slug: "partnership",
    name: "Mogul Growth Partnership",
    for: "Strategy plus multiple execution disciplines. We function as an extension of your leadership team.",
    items: [
      "Everything in Management",
      "Multiple Coordinated Disciplines",
      "Executive Growth Strategy",
      "Business Development",
      "Brand & Marketing Oversight",
      "Revenue Opportunity Development",
      "Accountability & Implementation Oversight",
      "Coordination With Internal Teams",
    ],
    startingAt: "From $2,500+/mo",
  },
  {
    slug: "projects",
    name: "Project Engagements",
    for: "Discrete projects: websites, brand builds, launches, SOP builds, government/proposal readiness.",
    items: [
      "Website Development or Redesign",
      "Brand Identity Systems",
      "Launch Strategy & Coordination",
      "SOP & Systems Buildout",
      "Government & Proposal Readiness",
    ],
    startingAt: "Custom project fee",
  },
];

export const FAQS = [
  { q: "Who do you work with?", a: "Local business owners, startups, restaurants, retailers, contractors, home-service providers, hotels, professional service firms, and community-based organizations across Dallas–Fort Worth." },
  { q: "Do you only work with restaurants and hotels?", a: "No. We serve a broad range of local businesses across many industries — hospitality is just one of them." },
  { q: "Can you help a new business?", a: "Yes. We support brand positioning, launch strategy, website, and the operational foundation new businesses need to open with confidence." },
  { q: "Can you redesign an existing website?", a: "Yes. We redesign websites to better reflect your business today and to make it easier for customers to take the next step." },
  { q: "Do you manage social media?", a: "Yes. We offer content planning, post creation, promotional graphics, scheduling, and platform management." },
  { q: "Do you offer ongoing monthly support?", a: "Yes. Many clients continue with monthly advisory, marketing, or operations support after their initial project." },
  { q: "Do you guarantee business growth?", a: "No responsible advisor guarantees growth. We commit to focused strategy, honest guidance, and consistent execution." },
  { q: "What happens during the Growth Assessment?", a: "We review your goals, marketing, online presence, and operations to identify your most important next steps. There is no obligation." },
  { q: "Do you work outside Dallas–Fort Worth?", a: "Our home base is DFW, but we work with clients throughout Texas and select engagements beyond." },
  { q: "How do consultations begin?", a: "They typically begin with a Growth Assessment or a scheduled consultation. From there we recommend a right-sized engagement." },
];

export const VALUES = [
  { title: "Integrity", body: "Honest guidance, clear communication, and work we are proud to sign our name to." },
  { title: "Strategy", body: "Every recommendation begins with understanding your business, your customer, and your market." },
  { title: "Excellence", body: "Thoughtful execution across brand, website, marketing, and operations." },
  { title: "Accountability", body: "We take ownership of the work and the outcomes we can influence." },
  { title: "Creativity", body: "Practical creativity — ideas that also work in the real world." },
  { title: "Practical Execution", body: "Strategy on the page is only valuable when it lives in the business." },
  { title: "Community Impact", body: "When local businesses grow, neighborhoods grow with them." },
];

export const PORTFOLIO = [
  {
    slug: "black-collar-coffee",
    name: "Black Collar Coffee Co.",
    category: "Brand & Digital Presence",
    image: "https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=1200&q=80",
    problem: "New coffee concept needing a professional identity, digital footprint, and consistent customer messaging to launch with confidence.",
    work: "Brand foundation, launch strategy, digital presence build-out, and ongoing marketing coordination.",
    result: "A cohesive brand identity in-market and a working framework for consistent day-to-day customer communication.",
  },
  {
    slug: "the-mad-turkey",
    name: "The Mad Turkey",
    category: "Hospitality Operations & Marketing",
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1200&q=80",
    problem: "Hospitality concept needing sharper operational systems and consistent promotional visibility.",
    work: "Operations review, brand positioning support, and promotional campaign coordination.",
    result: "Tighter service execution and a more consistent promotional rhythm across channels.",
  },
  {
    slug: "hands-n-hammer",
    name: "Hands N Hammer Restoration",
    category: "Contractor Marketing & Web",
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1200&q=80",
    problem: "Restoration contractor needing a credible online presence, lead-generation infrastructure, and better follow-up systems.",
    work: "Website build, lead-form and inquiry workflow, and digital foundations for local search visibility.",
    result: "A professional web presence backed by a repeatable inbound inquiry process.",
  },
  {
    slug: "heal-to-hear",
    name: "Heal to Hear",
    category: "Brand & Launch Strategy",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=1200&q=80",
    problem: "Wellness-focused venture needing a purposeful brand foundation and launch plan.",
    work: "Brand positioning, messaging, visual direction, and launch-phase coordination.",
    result: "A launch-ready brand system with clear positioning and public-facing collateral.",
  },
  {
    slug: "drain-pros-plus",
    name: "Drain Pros Plus",
    category: "Home Services · Digital Presence",
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=1200&q=80",
    problem: "Plumbing and home-services company needing a professional digital home, service-area visibility, and simplified booking.",
    work: "Website foundation, service-page structure, and lead-capture workflow.",
    result: "A credible online presence that supports service inquiries and dispatch.",
  },
];

export const TESTIMONIALS = [
  // Testimonials will appear here once real client reviews are added with written permission.
  // Each entry: { name, business, industry, review, photo, permission_confirmed }
];

export const CONTACT = {
  company: "The Mogul Group Advisors",
  address_line_1: "539 W. Commerce St #8101",
  address_line_2: "Dallas, TX 75208",
  email: "info@TheMogulAdvisors.com",
  phone: "817-799-7274",
  phone_href: "tel:8177997274",
  hours: "Monday–Friday · 9:00 AM – 6:00 PM CT",
  response_time: "We typically respond within one business day.",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/how-we-help", label: "How We Help" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/growth-assessment", label: "Growth Assessment" },
  { to: "/contact", label: "Contact" },
];
